$(document).ready(function () {
  const p = $('body').attr('p');
  const a = $('body').attr('a');
  const urlParam = new URLSearchParams(window.location.search);

  if (p !== 'inventory' || a !== 'list' || urlParam.get('type') !== 'count') {
    return;
  }

  const locationId = $('body').attr('event_id');
  const $sheet = $('#scan-count-sheet');
  const $form = $('#scan-count-form');
  const $qty = $('#scan-count-qty');
  const $save = $form.find('.scan-count-save');
  let scannedProduct = null;
  let forceSave = false;
  let isLookingUp = false;
  let isSaving = false;
  const QTY_MAX_LENGTH = 8;

  function formatAmount(value) {
    const number = parseFloat(value);
    if (isNaN(number)) return '0';
    return String(Math.round(number * 1000) / 1000).replace('.', ',');
  }

  function parseQty(value) {
    // Norwegian decimal keyboards give a comma
    const number = parseFloat(String(value || '').replace(',', '.'));
    return isNaN(number) ? NaN : number;
  }

  function fillTemplate(template, values) {
    return String(template || '').replace(/{{\s*(\w+)\s*}}/g, function (m, key) {
      return values[key] !== undefined ? values[key] : '';
    });
  }

  function showError(message) {
    $form.find('.scan-count-error').text(message).removeClass('d-none');
  }

  function showProduct(product) {
    scannedProduct = product;
    forceSave = !!product.other_user_count;
    $form.find('.scan-count-name').text(product.name);
    $form.find('.scan-count-ean').text(product.ean);
    $form.find('.scan-count-counted').text(formatAmount(product.counted_amount));
    $form
      .find('.scan-count-counted-wrapper')
      .toggleClass('d-none', !(parseFloat(product.counted_amount) > 0));
    $form.find('.scan-count-error').addClass('d-none').text('');
    const $conflict = $form.find('.scan-count-conflict');
    if (product.other_user_count) {
      $conflict
        .text(
          fillTemplate($sheet.data('conflict-text'), {
            name: product.other_user_count.first_name,
            amount: formatAmount(product.other_user_count.amount_after),
          })
        )
        .removeClass('d-none');
    } else {
      $conflict.addClass('d-none').text('');
    }
    $qty.val('1').removeClass('is-invalid');
    $save.prop('disabled', false);
    CameraBarcodeScanner.showSheet();
  }

  function pressKey(key) {
    let value = String($qty.val() || '');
    if (key === 'back') {
      value = value.slice(0, -1);
    } else if (key === ',') {
      if (value.indexOf(',') !== -1) return;
      value = (value === '' ? '0' : value) + ',';
    } else if (value.length < QTY_MAX_LENGTH) {
      value = value === '0' ? key : value + key;
    }
    $qty.val(value).removeClass('is-invalid');
  }

  function toggleCountList(isScanning) {
    // While scanning, the panel replaces the tabs and product list (header stays)
    $('.inventory-table')
      .children()
      .not('.product-order-header, #inventory-scan-panel')
      .toggleClass('inventory-scan-hidden', isScanning);
  }

  function lookUp(code) {
    if (isLookingUp) return;
    isLookingUp = true;
    $.ajax({
      type: 'POST',
      url: '/ajax/inventory/scan_count_product',
      data: { location_id: locationId, code: code },
      dataType: 'json',
    })
      .done(function (data) {
        if (data && data.product) {
          showProduct(data.product);
          return;
        }
        showToast({
          type: 'error',
          title: '',
          message: (data && data.error_message) || code,
          position: 'bottom-center',
          duration: 3000,
        });
        CameraBarcodeScanner.resume();
      })
      .fail(function (xhr) {
        if (xhr.responseJSON && xhr.responseJSON.redirect_url) {
          document.location.href = xhr.responseJSON.redirect_url;
          return;
        }
        showToast({
          type: 'error',
          title: '',
          message:
            (xhr.responseJSON && xhr.responseJSON.error_message) ||
            $sheet.data('error-text'),
          position: 'bottom-center',
          duration: 3000,
        });
        CameraBarcodeScanner.resume();
      })
      .always(function () {
        isLookingUp = false;
      });
  }

  function save() {
    if (!scannedProduct || isSaving) return;
    const qty = parseQty($qty.val());
    if (isNaN(qty) || qty <= 0) {
      $qty.addClass('is-invalid');
      return;
    }
    $qty.removeClass('is-invalid');
    isSaving = true;
    $save.prop('disabled', true);

    const formData = new FormData();
    formData.append('type', 'count');
    formData.append('location_id', locationId);
    formData.append('product_id', scannedProduct.product_id);
    formData.append('add_amount', qty);
    if (forceSave) {
      formData.append('force', true);
    }

    $.ajax({
      type: 'POST',
      url: '/ajax/inventory/save_temporary_product_stock',
      data: formData,
      cache: false,
      processData: false,
      contentType: false,
    })
      .done(function (data) {
        if (data.isSavedByOtherUser) {
          // Another user saved this product meanwhile: show it and let the next tap overwrite
          scannedProduct.other_user_count = {
            first_name: data.userFirstName,
            amount_after: data.amountAfter,
          };
          showProduct(scannedProduct);
          return;
        }
        const newAmount = (parseFloat(scannedProduct.counted_amount) || 0) + qty;
        const productId = scannedProduct.product_id;
        if (data.html !== undefined && data.html !== null) {
          $('#report-list').empty().append(data.html);
        }
        // Card layouts carry .amount-after-{id}; the desktop table input only has data-product-id
        $(
          `.amount-after-${productId}, input.amount-after[data-product-id="${productId}"]`
        )
          .val(newAmount)
          .attr('data-amount-after', newAmount);
        $(`.event-ticket-category-id-${productId}`).addClass(
          'temp-save-row-highlight'
        );
        $(`#product-${productId}`).addClass('temp-save-row-highlight');
        $('#save-stock-taking').prop('disabled', false);

        showToast({
          type: 'success',
          title: '',
          message: fillTemplate($sheet.data('saved-text'), {
            name: scannedProduct.name,
            amount: formatAmount(newAmount),
          }),
          position: 'bottom-center',
          duration: 2000,
        });
        scannedProduct = null;
        CameraBarcodeScanner.resume();
      })
      .fail(function (xhr) {
        if (xhr.responseJSON && xhr.responseJSON.redirect_url) {
          document.location.href = xhr.responseJSON.redirect_url;
          return;
        }
        showError(
          (xhr.responseJSON && xhr.responseJSON.error_message) ||
            $sheet.data('error-text')
        );
        $save.prop('disabled', false);
      })
      .always(function () {
        isSaving = false;
      });
  }

  $(document).on('click', '#inventory-scan-button', function (e) {
    e.preventDefault();
    toggleCountList(true);
    CameraBarcodeScanner.open($(this), {
      sheet: $sheet,
      container: $('#inventory-scan-panel'),
      onDetected: lookUp,
      onClose: function () {
        scannedProduct = null;
        toggleCountList(false);
      },
    });
    window.scrollTo(0, 0);
  });

  $form.on('submit', function (e) {
    e.preventDefault();
    save();
  });

  $form.on('click', '.scan-count-cancel', function (e) {
    e.preventDefault();
    scannedProduct = null;
    CameraBarcodeScanner.resume();
  });

  $form.on('click', '.scan-count-key', function (e) {
    e.preventDefault();
    pressKey(String($(this).data('key')));
  });

  // Physical keyboard (top row or numpad) behaves exactly like the on-screen keypad
  $(document).on('keydown', function (e) {
    if (!scannedProduct || $sheet.hasClass('d-none')) return;
    if (e.ctrlKey || e.metaKey || e.altKey) return;
    let key = null;
    if (/^[0-9]$/.test(e.key)) {
      key = e.key;
    } else if (e.key === ',' || e.key === '.' || e.key === 'Decimal') {
      key = ',';
    } else if (e.key === 'Backspace') {
      key = 'back';
    } else if (e.key === 'Enter') {
      e.preventDefault();
      save();
      return;
    } else if (e.key === 'Escape') {
      e.preventDefault();
      scannedProduct = null;
      CameraBarcodeScanner.resume();
      return;
    }
    if (key === null) return;
    e.preventDefault();
    pressKey(key);
  });
});
